document.addEventListener('DOMContentLoaded', function() {
    function checkBlocks() {
        const blockItems = document.querySelectorAll('.product-info__block-item[data-block-type="liquid"]');
        blockItems.forEach(block => {
            const liquidDiv = block.querySelector('.liquid');
            const feedatyDiv = block.querySelector('.feedaty_widget');
            if (liquidDiv && feedatyDiv && liquidDiv.dataset.hide === 'true' && 
                (feedatyDiv.textContent.trim() === '<!-- no feedbacks -->' || feedatyDiv.textContent.trim() === '')) {
                block.style.display = 'none';
            }
            if (liquidDiv && feedatyDiv && (liquidDiv.dataset.hide === 'false' || feedatyDiv.textContent.trim() != '')) {
                block.style.display = '';
            }
        });
    }

    // Controllo iniziale
    checkBlocks();

    // Osserva cambiamenti nel DOM del targetNode e richiama checkBlocks
    // per eventuali caricamenti di contenuti asincroni rispetto al dom
    const observer = new MutationObserver(checkBlocks);
    const targetNode = document.querySelector('.product-info__block-item[data-block-type="liquid"]');
    observer.observe(targetNode, {
        childList: true,
        subtree: true
    });


});